module.exports = __webpack_public_path__ + "img/powered-by-generac-white.c6b8be6a.svg";